function encriptString(argString: string) {
    const thisString = argString.toString();
    let encodedString = "";
    var charactersAndNumbers = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz/*-!@#$%^&*&*()_+=<>?`[]{}.~0123456789";
    var characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz/*-!@#$%^&*&*()_+=<>?`[]{}.~";
    var numbers = "0123456789";
    for(const singleChar of thisString) {
        encodedString += characters.charAt(Math.floor(Math.random() * characters.length));
        const randomNumber = numbers.charAt(Math.floor(Math.random() * numbers.length));
        encodedString += randomNumber;
        for(let index = 0; index < Number(randomNumber); index++) {
            encodedString += charactersAndNumbers.charAt(Math.floor(Math.random() * charactersAndNumbers.length))
        }
        encodedString += singleChar.charCodeAt(0);
    }

    return(encodedString)
}

function decriptString(argEncode: string | null) {
    let encodedString: string = "";

    if(argEncode === null) {
        return null;
    }
    else {
        encodedString = argEncode;
        let decodedString = "";
        let thisCharSample = "";
        let isFirstCounterChar = true;
        while(encodedString.length > 0) {
            if(encodedString[0].match("[0-9]")) {
                if(isFirstCounterChar && thisCharSample.length === 0) {
                    encodedString = encodedString.substr(Number(encodedString[0]) + 1);
                    isFirstCounterChar = false;
                }
                else {
                    isFirstCounterChar = true;
                    thisCharSample += encodedString[0];
                    encodedString = encodedString.substr(1);
                }
            }
            else {
                encodedString = encodedString.substr(1);
                decodedString += String.fromCharCode(Number(thisCharSample));
                thisCharSample = "";
            }
        }
        decodedString += String.fromCharCode(Number(thisCharSample));
        return(decodedString.substr(1))
    }
}

export {encriptString, decriptString}